import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { Tabs, Tab } from "@mui/material";
import { convertToSentenceCase } from "../Utils/utils";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export const TopBar = (props) => {
  const { categories, onOptionClick, selectedCat } = props;

  const handleChange = (event, newValue) => {
    onOptionClick(newValue);
  };

  return (
    <Stack
      sx={{
        display: {
          xs: "flex",
          sm: "flex",
          md: "flex",
          lg: "none",
          xl: "none",
        },
        padding: { xs: "5px", md: "5px" },
        flexDirection: "row",
        justifyContent: "center",
        flexWrap: "wrap",
        overflowX: "wrap",
        position: "sticky",
        top: "56px",
        backgroundColor: "#fffbfb",
        borderBottom: "1px solid #f9f0f0",
      }}
    >
      <Tabs
        value={selectedCat}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        allowScrollButtonsMobile
      >
        {categories.map((cat, index) => {
          return (
            <Tab
              label={convertToSentenceCase(cat.categoryDescription)}
              value={cat.id}
            />
          );
        })}
      </Tabs>
      {/* <Item
        key={`${cat.id} - ${index}`}
        component={Paper}
        elevation={12}
        sx={{
          margin: "5px 10px",
        }}
        onClick={() => onOptionClick(cat.id)}
      >
        <Typography
          sx={{
            color: ` ${
              selectedCat === cat.id ? "#972020" : "rgba(0, 0, 0, 0.87)"
            }`,
            margin: "5px",
          }}
          variant="body1"
        >
          {convertToSentenceCase(cat.categoryDescription)}
        </Typography>
      </Item> */}
    </Stack>
  );
};
